import React, { useState, useEffect } from 'react';
import Version from '../../package.json';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Alert } from 'reactstrap';
import { useDataSync } from './PouchDB/DataSyncProvider';

const useStyles = makeStyles((theme) => ({
        root: {
            '& > *': {
            margin: theme.spacing(1),
            },
        },
    }));

export default function SyincInfo() {

    const classes = useStyles();
    const { isManualSyncing } = useDataSync();
    const [visible, setVisible] = useState(false);
    const onDismiss = () => setVisible(false);

    useEffect(() => {

        // console.log("manual sync => ", isManualSyncing)
        if (isManualSyncing) {
            setVisible(true)
        } else {
            setVisible(false)
        }

    },[isManualSyncing])

    return (
        <>
        <div className={classes.root}>
            <Alert color="info" isOpen={visible} toggle={onDismiss}>
                Proses Replikasi Sedang Berlangsung
            </Alert>
        </div>
        </>
    );

}